export const userKinds = {
	UNKNOWN: 'unknown',
	ADMIN: 'admin',
	SUPER_ADMIN: 'super_admin',
};

export const rightPrefixes = {
	VIEW: 'view',
	EDIT: 'edit'
}
export const rightActivePrefixes = {
	ACTIVE: 'yes',
	INACTIVE: 'no'
}

// TODO
// apply individual rights to cancel/edit/etc of bookings per type!

export const managementRightsConstants = {
	VIEW: {
		DASHBOARD: 'view_dashboard',

		PRESENCE: 'view_presence',
		BOOKINGS_WORKPLACES: 'view_bookings_workplaces',

		BOOKINGS_MEETING_ROOMS: 'view_bookings_meeting_rooms',

		BOOKINGS_LUNCH: 'view_bookings_lunch',

		BOOKINGS_PARKING_SPOTS: 'view_bookings_parking_spots',

		BOOKINGS_REPORTS: 'view_bookings_reports',

		COMPANIES: 'view_companies',

		DEPARTMENTS: 'view_departments',

		FUNCTIONS: 'view_functions',

		TEAMS: 'view_teams',

		EMPLOYEES: 'view_employees',

		JOBTITLES: 'view_jobtitles',
		BUILDINGS: 'view_buildings',
		BUILDING_TIMESLOTS: 'view_building_timeslots',
		BUILDING_TEAMS_EMPLOYEES: 'view_building_teams_employees',
		BUILDING_CONTACT_PERSONS: 'view_building_contact_persons',


		FLOORS: 'view_floors',
		FLOOR_TIMESLOTS: 'view_floor_timeslots',
		FLOOR_TEAMS_EMPLOYEES: 'view_floor_teams_employees',

		ROOMS: 'view_rooms',
		ROOM_TIMESLOTS: 'view_room_timeslots',
		ROOM_TEAMS_EMPLOYEES: 'view_room_teams_employees',



		MESSAGES: 'view_messages',
		STATISTICS: 'view_statistics',
		QR_CODES: 'view_qr_codes',
		SETTINGS: 'view_settings'
	},
	EDIT: {
		BUILDINGS: 'edit_buildings',

		BOOKINGS_WORKPLACES_CANCEL: 'edit_bookings_cancel',
		BOOKINGS_WORKPLACES_SCAN_IN: 'edit_bookings_scan_in',
		BOOKINGS_WORKPLACES_ACCEPTED_STATUS: 'edit_bookings_accepted_status',

		BOOKINGS_MEETING_ROOMS_CANCEL: 'edit_meeting_rooms_cancel',
		BOOKINGS_MEETING_ROOMS_SCAN_IN: 'edit_meeting_rooms_scan_in',
		BOOKINGS_MEETING_ROOMS_ACCEPTED_STATUS: 'edit_meeting_rooms_accepted_status',

		BOOKINGS_LUNCH_CANCEL: 'edit_lunch_cancel',
		BOOKINGS_LUNCH_SCAN_IN: 'edit_lunch_scan_in',
		BOOKINGS_LUNCH_ACCEPTED_STATUS: 'edit_lunch_accepted_status',

		BOOKINGS_PARKING_SPOTS_CANCEL: 'edit_parking_spots_cancel',
		BOOKINGS_PARKING_SPOTS_SCAN_IN: 'edit_parking_spots_scan_in',
		BOOKINGS_PARKING_SPOTS_ACCEPTED_STATUS: 'edit_parking_spots_accepted_status',

		BUILDING_TIMESLOTS: 'edit_building_timeslots',
		BUILDING_TEAMS_EMPLOYEES: 'edit_building_teams_employees',
		BUILDING_CONTACT_PERSONS: 'edit_building_contact_persons',

		COMPANIES: 'edit_companies',

		DEPARTMENTS: 'edit_departments',

		FUNCTIONS: 'edit_functions',

		TEAMS: 'edit_teams',

		EMPLOYEES: 'edit_employees',

		JOBTITLES: 'edit_jobtitles',

		FLOORS: 'edit_floors',
		FLOOR_TIMESLOTS: 'edit_floor_timeslots',
		FLOOR_TEAMS_EMPLOYEES: 'edit_floor_teams_employees',

		ROOMS: 'edit_rooms',
		ROOM_TIMESLOTS: 'edit_room_timeslots',
		ROOM_TEAMS_EMPLOYEES: 'edit_room_teams_employees',


		MESSAGES: 'edit_messages',

		SETTINGS: 'edit_settings',
		
		TIMESLOTS: 'edit_timeslots',

		CREDITS: 'edit_credits',
	}
};

export const superAdminManagementRightsConstants = {
	VIEW: {
		SETTINGS: 'settings'
	},
	EDIT: {
		SETTINGS: 'settings'
	}
};

export const allManagementRightOptions = {
	VIEW: Object.values( managementRightsConstants.VIEW ),
	EDIT: [...Object.values( managementRightsConstants.EDIT ), ...Object.values( superAdminManagementRightsConstants.EDIT )]
}

export const adminRightOptions = {
	VIEW: Object.values( managementRightsConstants.VIEW ),
	EDIT:  Object.values( managementRightsConstants.EDIT ),
	//EDIT: []
};

export const superAdminRightOptions = {
	VIEW: [...Object.values( managementRightsConstants.VIEW ), ...Object.values( superAdminManagementRightsConstants.VIEW )],
	EDIT: [...Object.values( managementRightsConstants.EDIT ), ...Object.values( superAdminManagementRightsConstants.EDIT )]
};
